import events from "/events";
import { sendUniqEvent } from "/services/tracking/gtm";

// This is a global Cookiebot callback which is fired when user 1st time
// accepts consent and on every subsequent page load
// https://support.cookiebot.com/hc/en-us/articles/360003793854-Google-Tag-Manager-deployment

function informAboutCookieConsent() {
  if (window.Cookiebot.consent.preferences) {
    sendUniqEvent({ "event": "cookieconsent_preferences" });
  }

  if (window.Cookiebot.consent.statistics) {
    sendUniqEvent({ "event": "cookieconsent_statistics" });
  }

  if (window.Cookiebot.consent.marketing) {
    sendUniqEvent({ "event": "cookieconsent_marketing" });
  }

  // On IE11, occasionally events is undefined here, which interferes with
  // other scripts (like the page-loader and ab test toggler).
  // https://github.com/blinkist/blinkist-web/pull/2276
  if (typeof events !== "undefined") {
    events.emit("cookiebot:accept");
  }
}

// Check whether we were slower than Cookiebot and therefore missed the event
if (window.Cookiebot && window.Cookiebot.consented) {
  informAboutCookieConsent();
} else {
  window.addEventListener("CookiebotOnAccept", () => informAboutCookieConsent(), { once: true });
}

export function hasConsent() {
  return window.Cookiebot && window.Cookiebot.consent && window.Cookiebot.consent.statistics;
}
